import React, {useState, useEffect} from 'react';
import { motion, useScroll } from 'framer-motion';
import { Image, Button } from 'react-bootstrap';

import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaApple } from "react-icons/fa";
import Typewriter from './Typewriter';

import NavBar from './NavBar';
import './styles.css'
import './hero.css'

const sing = require('../assets/images/sing.jpg');
const feature1 = require('../assets/images/waveform.png');
const artText = require('../assets/images/art-text.png');
const feature3 = require('../assets/images/play.png');
const play = require('../assets/images/play.png');
const band = require('../assets/images/band.png');
const feature2 = require('../assets/images/film.png');

const HeroSection = () => {
    return (
      <div className="background">
        <NavBar />
        <div className="hero-container">
          <h1 className="hero-text">
            <span style={{ fontSize: '36px' }}>The App For Musical Collaboration.</span>
            <Typewriter
              text="Artseen Helps Local Musicans Find Each Other."
              delay={1000}
              style={{ fontSize: '28px' }}
            />
            <Typewriter
              text="We Are Building A Strong, Inclusive, And Creative Community."
              delay={4200}
              style={{ fontSize: '24px' }}
            />
          </h1>
        </div>
        {/* Rest of your content */}
      </div>
    );
};
 
      





/*             <div className='wrapper' >
                    <div className='image-container'>
                        <Image src={band}/>
                    </div>
                    <div className='art-container'>
                        <Image src={feature1}/>   
                    </div>
                    <div className='image-container'>
                        <Image src={feature2} />
                    </div>                                    
            </div>  */
        

export default HeroSection;

